import {Component, Input, OnInit, TemplateRef} from '@angular/core';
import {PrimeNgConfig, PrimeNgSupportService} from '@app/shared';
import {Table} from "primeng/table";
import {TreeTable} from "primeng/treetable";

@Component({
  selector: 'app-default-caption',
  templateUrl: './default-caption.component.html',
  styleUrls: ['./default-caption.component.css']
})
export class DefaultCaptionComponent implements OnInit {

  PrimeNgConfig = PrimeNgConfig;

  @Input() captionTemplate: TemplateRef<any>;
  @Input() searchCaptionTemplate: TemplateRef<any>;
  @Input() leftCaptionTemplate: TemplateRef<any>;
  @Input() rightCaptionTemplate: TemplateRef<any>;
  @Input() disableSearch: boolean;
  @Input() enabledExport: boolean;
  @Input() exportUsingTableColumn: boolean;
  @Input() exportTableColumns: string[];
  @Input() exportFileName: string;
  @Input() dt: Table | TreeTable;
  @Input() value: any[];

  constructor(private primeNgService: PrimeNgSupportService) {
  }

  ngOnInit(): void {
    if (this.dt instanceof Table) {
      this.value = this.dt.value;
    }
  }

}
